export function PencilIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0779 2.50136C11.2368 2.34241 11.4255 2.21632 11.6332 2.1303C11.8409 2.04428 12.0635 2 12.2883 2C12.513 2 12.7356 2.04428 12.9433 2.1303C13.151 2.21632 13.3397 2.34241 13.4986 2.50136C13.6576 2.66031 13.7837 2.84901 13.8697 3.05669C13.9557 3.26436 14 3.48695 14 3.71174C14 3.93653 13.9557 4.15912 13.8697 4.3668C13.7837 4.57447 13.6576 4.76317 13.4986 4.92212L5.32855 13.0922L2 14L2.90779 10.6714L11.0779 2.50136Z"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
    </svg>
  );
}
